<template>
	<div class="view-details-header bg-primary position-relative min-h-auto" v-if="surveyData">
			<div class="header-image">
				<img :src="surveyData.image" :alt="surveyData.name">
			</div>
			<div class="header-overlay"></div>
			<div class="container container--narrow position-relative pdt-30 pdb-30 pdl-16 pdr-16">
					<div class="t-headline11 t-color-whiteHigh font-m">
							{{ surveyData.name }}
					</div>
					<!-- <div class="t-body6 t-color-whiteHigh font-r pdt-16 pdb-12">
							차수분류1 > 차수분류2
					</div> -->
					<div class="t-body6 t-color-whiteHigh font-r pdb-12 mgt-16">
							{{ surveyData.category.text }}
					</div>
					<div class="mdc-chip-set banner--chip chip--outlined" role="grid" v-if="surveyData.tags.length">
							<div class="mdc-chip " role="row" v-for="(tag, index) in surveyData.tags"  :key="index">
									<div class="mdc-chip__ripple d-none"></div>
									<span role="gridcell">
											<span class="mdc-chip__text t-body4 font-r">#{{tag.name}}</span>
									</span>
							</div>
					</div>
					<div class="d-flex align-items-baseline justify-content-between mgt-24 mgb-10" v-if="surveyData.point.totalPoint > 0">
						<div class="d-flex align-items-baseline">
								<div class="t-body-6 pdr-4 t-color-whiteHigh">{{ $t("222") }}</div>
								<!-- <div class="t-headline5 pdr-8  t-color-whiteHigh font-b">15,000</div>
								<div class="t-body1 t-color-whiteMedium t-line-through-red">22,000</div> -->
						</div>
						<div
								class="t-headline5 font-rb d-flex align-items-center justify-content-center t-color-whiteHigh">
								<img src="@/assets/icon_point.svg" class="w-24 d-inline mgr-8" alt="">{{ $n(surveyData.point.totalPoint) }}
						</div>
					</div>

					<div v-if="todayDate > endDate">
						<button
							class="mdc-button mdc-button--raised bg-disableBtn t-color-disableBtnText w-full mgt-24"
							disabled
						>
							
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{ $t("703") }}</span>
						</button>
					</div>

			<div v-else-if="isAuthToken">
					<button class="mdc-button  bg-disableBtn t-color-disableBtnText w-full mgt-24"
						disabled v-if="surveyData.progression.value === 'WAITING'">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{ $t("703") }}</span>
					</button>
					<button class="mdc-button  bg-mainBtn t-color-mainBtnText w-full mgt-24"
					 @click="takeSurvey(surveyData.progression.value)" @keypress="takeSurvey(surveyData.progression.value)" tabindex="0"
						v-if="surveyData.progression.value === 'APPLICATION'" >
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{ $t("223") }}</span>
					</button>
						<button class="mdc-button  bg-mainBtn t-color-mainBtnText w-full mgt-24"
						@click="takeSurvey(surveyData.progression.value)" @keypress="takeSurvey(surveyData.progression.value)" tabindex="0"
						v-if="surveyData.progression.value === 'RESPONDENT'">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{ $t("3091") }}</span>
					</button>
						<button class="mdc-button  bg-mainBtn t-color-mainBtnText w-full mgt-24"
							@click="moveSurveyResult()" @keypress="moveSurveyResult()" tabindex="0"
							v-if="surveyData.progression.value === 'RESPONDING'">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{ $t("3091") }}</span>
					</button>
						<button class="mdc-button  bg-mainBtn t-color-mainBtnText w-full mgt-24"
								@click="moveSurveyResult()" @keypress="moveSurveyResult()" tabindex="0"
						v-if="surveyData.progression.value === 'SUBMITTED'">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{ $t("752") }}</span>
					</button>
						<button class="mdc-button  bg-disableBtn t-color-disableBtnText w-full mgt-24"
						disabled
						v-if="surveyData.progression.value === 'NONRESPONSE'">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{ $t("703") }}</span>
					</button>
			</div>
			<div v-else>
				<button class="mdc-button  bg-mainBtn t-color-mainBtnText w-full mgt-24"
					@click="takeSurvey()" @keypress="takeSurvey()" tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{ $t("3091") }}</span>
				</button>
			</div>
			</div>
	</div>
</template>

<script>
import httpService from "@/api/httpService";
// import loginApi from '@/api/loginApi.js'
import surveyApi from "@/api/surveyApi.js";
import {MDCRipple} from '@material/ripple'
import {MDCChipSet} from '@material/chips';
// Mixin 선언
import { surveyMixin } from "@/mixins/survey.js";

/*
WAITING 참여대기 참여 가능한 기간 이전 상태

APPLICATION 참여가능 참여 가능한 기간이지만 참여하지 않은 상태

RESPONDENT 응답가능 참여 후 아직 응답하지 않았지만 요청일이 응답일 내에 있는 상태

RESPONDING 응답중 응답기간 내에 설문 응답 시작을 하고 제출 이전

SUBMITTED 제출 설문을 제출한 상태

NONRESPONSE 미응시 설문 응시를 하지 않고 기간이 지난 상태
*/
export default {
	props: ["surveyData","todayDate", "endDate"],
	data() {
		return {
			authToken: "",
			distId: "",
			respondentId: "",
		};
	},

	mixins: [surveyMixin],

	mounted() {
		// console.log('authToken', this.authToken);
		this.setMaterialUi()
		const chipSetEl = document.querySelector('.mdc-chip-set');
		const chipSet = new MDCChipSet(chipSetEl);
	},

	updated() {
		this.authToken = localStorage.getItem("token");
		this.distId = this.surveyData.id;
		this.respondentId = this.surveyData.respondentId;
	},

	computed: {
		isAuthToken() {
			return !!this.authToken;
		},
	},

	methods: {
		moveLogin() {
			const loginPath = `/login?redirectPath=${encodeURIComponent(
				this.$route.fullPath
			)}`;
			this.$router.push(loginPath);
		},

		async takeSurvey(progression) {
			let authStatus = await this.checkLogin();
			if (authStatus) {

				if (progression === "APPLICATION") {
					let params = {
						distId: this.distId,
					};
					surveyApi.surveyIndependentEnter(params).then((response) => {
						this.respondentId = response.data.data.id;
						// console.log("surveyIndependentEnter", response.data.data);
						this.moveSurveyIntro();
					});
				} else if (progression === "RESPONDENT") {
					this.moveSurveyIntro();
				} else if (progression === "RESPONDING") {
					this.moveSurveyIntro();
				} else if (progression === "SUBMITTED") {
					this.moveSurveyIntro();
				} else if (progression === "NONRESPONSE") {
				}
			} else {
				this.moveLogin();
			}
		},

		// checkLogin() {
		//     // httpService.setAuthInHeader(localStorage.getItem('token'))
		//     return new Promise((resolve, reject) => {
		//         loginApi.validToken().then((response) => {
		//             resolve(true)
		//         }).catch((err) => {
		//             resolve(false)
		//         })
		//     })

		// },

		moveLogin() {
			const loginPath = `/login?redirectPath=${encodeURIComponent(
				this.$route.fullPath
			)}`;
			this.$router.push(loginPath);
		},

		moveSurveyIntro() {
			let params = {
				distId: this.distId,
				respondentId: this.respondentId,
			};

			this.$router.push({
				name: "IndependentSurveyIntro",
				params: params,
			});
		},
		 setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
					let button = new MDCRipple.attachTo(el)
					return button
			})
		},
	},
	
};
</script>

<style>
</style>
